import { Link } from 'react-router-dom';
import { InfoCircledIcon } from '@radix-ui/react-icons';

import { Routes } from 'config/constants';
import MarginAmount from 'components/FormRequestBlock/MarginAmount';
import Brand from 'components/FormRequestBlock/Brand';
import { Typography } from 'components/ui/typography';
import { useAppSelector } from 'app/store';
import { selectUserInfo } from 'app/store/user';
import { canAccessRoute, canRead, canWrite } from 'app/access';

import './style.scss';

const sectionHeaderCn = 'mb-5 mt-16';

const Page = () => {
  const userInfo = useAppSelector(selectUserInfo);
  const showApiKeysLink = canAccessRoute(userInfo, Routes.ApiKeys);
  const canManageMargin = canWrite(userInfo, 'checkout_intents');
  const canViewBranding = canRead(userInfo, 'branding');

  return (
    <div className="account-container">
      {showApiKeysLink && (
        <Typography
          as="div"
          variant="small"
          role="status"
          className="mt-8 flex items-start gap-3 border border-[var(--line)] bg-[var(--surface-2)] p-4 text-[var(--text)]"
        >
          <InfoCircledIcon className="mt-0.5 h-4 w-4 shrink-0 text-[var(--text-muted)]" />
          <div>
            API keys and webhooks have moved to{' '}
            <Typography variant="link" asChild>
              <Link to={Routes.ApiKeys}>Developers &rsaquo; API Keys</Link>
            </Typography>
            .
          </div>
        </Typography>
      )}

      {canManageMargin && (
        <>
          <Typography variant="h3" as="h2" className={sectionHeaderCn}>
            Margin
          </Typography>
          <MarginAmount />
        </>
      )}

      {canViewBranding && (
        <>
          <Typography variant="h3" as="h2" className={sectionHeaderCn}>
            Branding
          </Typography>
          <Brand />
        </>
      )}
    </div>
  );
};

export default Page;
